import React from 'react'
import Link from 'gatsby-link'
import Navigation from '../components/Navigation'

import '../templates/blog-post.scss'

const BlogPage = ({ data }) => {
  return (
    <div>
      <Navigation />
      <div className="container">
        {data.allMarkdownRemark.edges.map(({ node }) =>
          <div style={{ padding: '15px 0 90px' }} className="row" key={node.id}>
            <div className="col-sm-12">
              <Link to={ `post${node.fields.slug}` }>
                <img src={ `/images/${node.frontmatter.featuredImage}` } />
                <h3>
                  {node.frontmatter.title}{" "}
                  <span color="#BBB">— { node.frontmatter.date }</span>
                </h3>
              </Link>
              <div className="post">
                <p>
                  { node.excerpt } <Link to={ `post${node.fields.slug}` }>Read More</Link>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export const query = graphql`
query BlogQuery {
  allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
    totalCount
    edges {
      node {
        id
        frontmatter {
          date(formatString: "DD MMMM, YYYY")
          featuredImage
          title
        }
        fields {
          slug
        }
        excerpt(pruneLength: 500)
      }
    }
  }
}
`

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog.js